import * as yup from "yup";

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	ada001Descricao: yup.string().required(translate("Descrição da norma é requerida")),
	ada001Dtvalini:yup.date()
		.required(translate("Data inicial da validade é requerida"))
		.typeError(translate("Data inicial com data inválida"))
		.nullable(),
	ada001Dtvalfim: yup.date()
		.required(translate("Data final da validade é requerida"))
		.typeError(translate("Data final com data inválida"))
		.nullable()
		.when("ada001Dtvalini",(initialDate,schema) => initialDate ? schema.min(initialDate,translate("Data final não pode ser menor que a inicial")):schema),
	ada001Ativo: yup.boolean()
});

export default  addAndChangeSchema;
